import { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import {
  allAutocompleteThunk,
  allSuggestionsThunk,
  combinedSearchThunk,
  selectSearchAutoCompleteQueryPlusText,
} from "../../../features/enhancedSearch";
import { updateState } from "../../../features/counter/counterSlice";
import AppSearchBox from "../AppSearchBox/AppSearchBox";

const AppSearchBar = ({ push, searchValue, setSearchValue }) => {
  const inputFieldRef = useRef(null);
  const dispatch = useDispatch();
  const { debounceFn } = useDebounce();
  const suggestedText = useSelector(selectSearchAutoCompleteQueryPlusText);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const typeAheadAutoComplete = useCallback(
    debounceFn((searchTerm) => {
      dispatch(allAutocompleteThunk({ searchText: searchTerm }));
    }, 600),
    []
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const typeAheadSuggestions = useCallback(
    debounceFn((searchTerm) => {
      dispatch(allSuggestionsThunk({ searchText: searchTerm }));
    }, 600),
    []
  );

  const keyupSearchHandler = async (e) => {
    const searchInputValue = e.target.value.toLowerCase().trim();

    if (searchInputValue.length !== 0) {
      performSearchOnEnter(e);
      typeAheadSuggestions(searchInputValue);
      typeAheadAutoComplete(searchInputValue);
    }
  };

  const performSearchOnEnter = (event) => {
    if (event.keyCode === 13 && searchValue.length >= 2) {
      console.log("this is in the app search search term", searchValue);
     
      // flag C5State so a topic opened from these results reports as a search
      dispatch(
        updateState({
          C5State: {
            eventType: "Searches Regular",
            searchTerm: searchValue || "",
          },
        })
      );
      dispatch(combinedSearchThunk({ searchText: searchValue }));
      push(
        "/searchAction/?appendedinputbuttons=" + encodeURIComponent(searchValue)
      );
      inputFieldRef.current.blur();
    }
  };

  const keydownSearchHandler = (e) => {
    if (
      (e.keyCode === 9 || e.key === "Tab") &&
      searchValue?.length >= 3 &&
      suggestedText !== searchValue &&
      suggestedText !== ""
    ) {
      setSearchValue(suggestedText);
      e.preventDefault();
    }
  };

  const clearSearch = () => {
    setSearchValue("");
    inputFieldRef.current.blur();
  };

  const goBack = () => {
    push(-1);
  };

  return (
    <AppSearchBox
      searchValue={searchValue}
      keydownSearchHandler={keydownSearchHandler}
      keyupSearchHandler={keyupSearchHandler}
      suggestedText={suggestedText}
      setSearchValue={setSearchValue}
      inputFieldRef={inputFieldRef}
      clearSearch={clearSearch}
      push={push}
      goBack={goBack}
    ></AppSearchBox>
  );
};

export default AppSearchBar;
